<!-- About Start -->
<div class="container-xxl about " style=" background: linear-gradient(rgba(0, 0, 0, .1), rgba(0, 0, 0, .1)), url(assets/img/a.svg) left center no-repeat;
                        background-size: cover;">
    <div class="container">
        <div class="row g-0">
            <div class="col-lg-6">
                <div class="h-100 d-flex align-items-center justify-content-center" style="min-height: 300px;">
                    <h1 class="title-generale " style="color: white;">Talents Plus Afrique </h1>
                </div>
            </div>
            <div class="col-lg-6 pt-lg-2 mb-lg-5 wow fadeIn" data-wow-delay="0.5s">
                <div class="bg-white rounded-top p-3 mt-lg-5">
                    <p class=" customize-title" style="color: #00027D;">Notre Vision</p>
                    <p style="font-weight: bold;">“ETRE LE LABEL DE GRH DANS LA ZONE CEDEAO ET ETRE L’UN
                        DES 05
                        MEILLEURS CABINETS DANS CHAQUE PAYS
                        D’IMPLANTATION D’ICI
                        2030”</p>


                    <a class="btn  rounded-pill py-3 px-5" style="background-color: #FF5A00; color: white;"
                        href="contact/benin-tpc">Contactez
                        nous</a>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- About End -->

<section class="ett" style="margin:50px auto;">
    <div class="container">
        <div class="row">
            <div class="col-12 col-sm-7 col-lg-7 order-1" style="margin: auto;">
                <div>

                    <h1 class="customize-title" style="color: #00027D; font-weight: bold;">Notre Mission</h1>
                    <h5 class="text-blue">“CREER LA PASSION ET L’ENERGIE”</h5>
                    <p>Par l’excellence de nos travaux et notre attitude, nous mettons sur orbite de réussite et de
                        performance les talents et
                        les entreprises.
                    </p>
                </div>
            </div>
            <div class="col-12 col-sm-5 col-lg-5 order-2" style="margin: auto;"><img
                    style="width: 100%;    border-radius: 10%;" src="assets/img/conseils.jpg"></div>
        </div>
    </div>
</section>

<section
    style="padding: 50px 0px 20px; background: url('assets/img/back-about.svg'); background-size: cover; background-position: center; background-repeat: no-repeat;">
    <div class="container">
        <div class="row">
            <div class="col-12 col-sm-5 col-lg-5" style="display: flex;
    align-items: center;">
                <img class="assets/img-about" style="width: 100%;" src="assets/img/tpa.jpg">
            </div>
            <div class="col-12 col-sm-7 col-lg-7" style="margin: auto;">

                <h1 class="customize-title" style="color: #00027D; font-weight: bold;">Nos valeurs</h1>
                <p class="text-blue"><i class="fa fa-hand-o-right mr-2 " aria-hidden="true"></i> <b>JEUNESSE D’ESPRIT
                        :</b>
                    Ouverture d’esprit - Adaptation permanente - Fougue et Energie</p>
                <p class="text-blue"><i class="fa fa-hand-o-right mr-2 " aria-hidden="true"></i> <b>OBLIGATION DE
                        RESULTAT
                        :</b>Professionnalisme - Standards internationaux/Qualité - Discipline</p>
                <h6 class="text-blue"><i class="fa fa-hand-o-right mr-2 " aria-hidden="true"></i> INNOVATION</h6>
                <p>Pionnier dans nos domaines - Amélioration continue - Pionnier dans la digitalisation</p>
                <h6 class="text-blue"><i class="fa fa-hand-o-right mr-2 " aria-hidden="true"></i> ETHIQUE</h6>
                <p>Fidélité - Sens de l’honneur - Fiabilité
                </p>
            </div>
        </div>
    </div>
</section>

<section class="mb-5" style="">
    <div class="container">
        <div class="row">

            <div class="col-12 col-sm-7 col-lg-7" style="margin: auto;">

                <h1 class="customize-title" style="color: #00027D; font-weight: bold;">Nos principes </h1>
                <p>Nous avons cinq principes directeurs qui nous guident vers notre Mission comme une boussole</p>
                <h6 class="text-blue"><i class="fa fa-hand-o-right mr-2 " aria-hidden="true"></i> Le respect de la
                    dignité de tout homme et des lois de chaque pays:</h6>
                <p>Nous en faisons un point d’honneur</p>
                <h6 class="text-blue"><i class="fa fa-hand-o-right mr-2 " aria-hidden="true"></i> La liberté dans la
                    responsabilité:</h6>
                <p>Nous la défendons</p>
                <h6 class="text-blue"><i class="fa fa-hand-o-right mr-2 " aria-hidden="true"></i> Marque Talents Plus
                    (digne d’appel):</h6>
                <p>Nous nous engageons</p>
                <h6 class="text-blue"><i class="fa fa-hand-o-right mr-2 " aria-hidden="true"></i> La gratitude,
                    l’humilité et la simplicité:</h6>
                <p>Nous les prônons</p>
                <h6 class="text-blue"><i class="fa fa-hand-o-right mr-2 " aria-hidden="true"></i> La fraternité et la
                    grâce divine:</h6>
                <p>Nous les cultivons</p>
            </div>
            <div class="col-12 col-sm-5 col-lg-5 mt-2">
                <img class="assets/img-about" style="width: 100%;" src="assets/img/principes.jpg">
            </div>
        </div>
    </div>
</section>
<section class="newsletter"
    style="background: url('assets/img/back-news.svg'); background-size: cover; background-position: center; background-repeat: no-repeat;">
    <div class="container">
        <div class="row">
            <div class="col-12 col-sm-7 col-lg-7">
                <h2 class="customize-title">Ne ratez plus rien</h2>
                <p>Abonnez-vous à nos newsletters. Selon vos centres d'intérêts, recevez nos offres d'emplois, nos avis
                    de
                    formation, des actualités sur l'entreprise. Abonnez-vous maintenant.</p>
            </div>
            <div class="col-12 col-sm-5 col-lg-5" style="margin: auto;">
                <form>
                    <div class="mb-3 col-md-12" style="padding: 0px !important;">
                        <!-- <label class="form-label">Votre email<span>*</span></label> -->
                        <input type="email" class="form-control" id="" placeholder="Email">
                    </div>
                    <div class="mb-3 col-md-12" style="padding: 0px !important;">
                        <button type="submit" class="btn btn-submit-white">Envoyer</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</section>
<app-confiance></app-confiance>